import _orderBy from 'lodash/orderBy';
// Custom
import { dateFormatter, dateQuery } from '../utils/DateUtils';

/**
* Utils
*/
const sortPeriods = (periods, fields = ['begin'], dirs = ['asc']) => (_orderBy(periods, fields, dirs));

const periodId = (period) => (`${period.begin ? dateFormatter.toUnixTimestamp(period.begin) : 'n'}${period.end ? dateFormatter.toUnixTimestamp(period.end) : 'n'}`);

const periodIsValid = (period) => ((period.begin && period.end) ? dateQuery.isBefore(period.begin, period.end) : true);

const periodsOverlap = (period1, period2) => {
  let overlap = false;
  if (period1.begin && period1.end) {
    if (period2.begin && period2.end && (dateQuery.isBetween(period2.begin, period1.begin, period1.end) || dateQuery.isBetween(period2.end, period1.begin, period1.end))) {
      overlap = true;
    } else if (period2.begin && period2.end && dateQuery.isSameOrBefore(period2.begin, period1.begin) && dateQuery.isSameOrAfter(period2.end, period1.end)) {
      overlap = true;
    } else if (!period2.end && dateQuery.isBefore(period2.begin, period1.end)) {
      overlap = true;
    } else if (!period2.begin && dateQuery.isAfter(period2.end, period1.begin)) {
      overlap = true;
    }
  } else if (period1.begin) {
    if (period2.begin && period2.end && (dateQuery.isSameOrAfter(period2.begin, period1.begin) || dateQuery.isAfter(period2.end, period1.begin))) {
      overlap = true;
    } else if (!period2.end) {
      overlap = true;
    } else if (!period2.begin && dateQuery.isAfter(period2.end, period1.begin)) {
      overlap = true;
    }
  } else if (period1.end) {
    if (period2.begin && period2.end && (dateQuery.isBefore(period2.begin, period1.end) || dateQuery.isSameOrBefore(period2.end, period1.end))) {
      overlap = true;
    } else if (!period2.end && dateQuery.isBefore(period2.begin, period1.end)) {
      overlap = true;
    } else if (!period2.begin) {
      overlap = true;
    }
  }

  return overlap;
};

/**
* Model
*/
const period = {
  // Name
  name: 'period',

  // Sort elements
  sortElements: sortPeriods,

  // Utils
  id: periodId,
  isValid: periodIsValid,
  overlap: periodsOverlap,
};

module.exports = period;



// WEBPACK FOOTER //
// ./models/period.js